import { AppData } from '../models/appdata'
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
//import { Observable } from 'rxjs/Observable';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
//import 'rxjs/add/operator/retry';
import { Router } from '@angular/router';
import { ApiResponseModel } from '../models/api_response_model';
import { ActorImageRequest, ActorDocRequest } from '../models/actor/actor';
import { ApiRequestModel } from '../models/api_request_model';
import { DownloadFileRequest } from '../models/docs/doc.model';
import {  FDDocRequest, FDSectionRequest, FDSectionFieldRequest, FDActorDocRequest, FDActorReportDetailsDocRequest, FdActorDocReportDetailsBySectionCode } from '../models/formdesign/fd.model';
import { CustomCodeTypeRequest_ } from '../models/master/mastermodel';


 

@Injectable()
//@Injectable({ providedIn: "root" })
export class FDService {


  constructor(private http: HttpClient, private router: Router) {


  }
  GetCustomDataByRequestedType_(SendCustomCodeTypeRequest: CustomCodeTypeRequest_
  ) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}MasterData/GetCustomCodeTypeRequest`, (SendCustomCodeTypeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)

      }
    ).pipe(catchError(this.handleError));

  }

  GetFdDocTemplateController(SendFDDocRequest: FDDocRequest) {



    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}FD/GetFdDocTemplates`, (SendFDDocRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }


  SaveFdDocTemplate(SendFDDocTemplate: FDDocRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}FD/SaveFdDocTemplate`, (SendFDDocTemplate),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }



  GetFdSectionsController(SendFDSectionRequest: FDSectionRequest) {



    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}FD/GetFdSectionsController`, (SendFDSectionRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }


  SaveFdSectionTemplate(SendFDSectionRequest: FDSectionRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}FD/SaveFdSectionTemplate`, (SendFDSectionRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //
  GetFdSectionDetailsController(SendFDSectionFieldRequest: FDSectionFieldRequest) {



    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}FD/GetFdSectionDetailsController`, (SendFDSectionFieldRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }


  SaveFdSectionFieldsTemplate(SendFDSectionFieldRequest: FDSectionFieldRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}FD/SaveFdSectionFieldsTemplate`, (SendFDSectionFieldRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //
  SaveFdActorReportDoc(SendFDActorDocRequest: FDActorDocRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}FD/SaveFdActorReportDoc`, (SendFDActorDocRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  GetFdActorReportsDocController(SendFDActorDocRequest: FDActorDocRequest) {



    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}FD/GetFdActorReportsDocController`, (SendFDActorDocRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }


  GetFdActorDocReportDetailsController(SendFDActorDocRequest: FDActorDocRequest) {



    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}FD/GetFdActorDocReportDetailsController`, (SendFDActorDocRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  GetFdActorDocReportDetailsBySectionCodeController(SendFdActorDocReportDetailsBySectionCode: FdActorDocReportDetailsBySectionCode) {



    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}FD/GetFdActorDocReportDetailsBySectionCode`, (SendFdActorDocReportDetailsBySectionCode),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }


  //
  SaveFDActorDocReportDetails(SendFDActorReportDetailsDocRequest: FDActorReportDetailsDocRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}FD/SaveFDActorDocReportDetails`, (SendFDActorReportDetailsDocRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }




  private handleError(error: any) {


    if (error.status === 400) {

      return Promise.reject('Request Failed Due to Bad Request..!');
    }
    //else if (error.status === 401) {
    //  console.log('Your Session ExpireD......!');

    //  //this.router.navigate(['signinpage']);
    //  //return false;
    // // this.router.navigate(['/']);
    //  //return Promise.reject('UnAuthorised Request..!');
    //  return this.unauthorised();

    //}
    else if (error.status === 401) {

      //  this.router.navigate(['login']);;;
      //return this.unauthorised();
      return Promise.reject('401 - Unauthorized');

    }
    else if (error.status === -1212401) {

      //  this.router.navigate(['login']);;;
      return this.unauthorised();
      //return Promise.reject('UnAuthorised Request..!');

    }
    else if (error.status === 500) {
      return Promise.reject('Internal Server Error..!');

    }
    else if (error.status === 415) {

      return Promise.reject('Request Failed Due to Unsupported Media Type..!');
    }
    else if (error.status === 404) {
      return Promise.reject('Page Not Found..!');

    }
    else {


      let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      return Promise.reject(error.message || error);
    }
  }
  unauthorised(): Observable<any> {

    this.router.navigate(['signinpage']);
    return throwError(() => ({}));
  }

}
